import React, { FC } from 'react'

import { AutoStory, PeakStory } from '..'
import { FeedItemProps } from './ProjectFeed.props'

export const FeedItem: FC<FeedItemProps> = ({
  story,
  factSources,
  country,
  handleModal,
  storyItem
}) => {

  if (story.argument_type === 'radio' || story.argument_type === 'stream') {
    return (
      <AutoStory
        story={story}
      />
    )
  }

  if (story.argument_type === 'peak') {
    const limit = factSources.find((fact) => fact.chart === story?.facts?.chart)?.import_limit

    return (
      <PeakStory
        story={story}
        chartData={`${limit || ''} ${country || ''}`}
      />
    )
  }

  return typeof storyItem !== 'undefined' ? (
    <>{storyItem(story, { handleModal: handleModal })}</>
  ) : null
}
